import React, { useMemo } from 'react';
import Select from 'react-select';
import styles from './MarketGroups.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setMarketsCollapsed, setSelectedMarketGroup } from '../../../../store/actions/markets';
import { MARKET_GROUPS_ALL_ID } from '../../../../constants/defaultValues';
import { getTranslation } from '../../../../utils/translation';
import LocalStorage from '../../../../utils/localStorage';
import {
    filterTemplatesByMarketStatus,
    filterTemplatesByMarketType,
} from '../../../../utils/market-groups';

const groupLimit = 5;

const MarketGroups = ({ markets }) => {
    const dispatch = useDispatch();

    const marketGroups = useSelector(state => state.allMarkets.filteredMarketGroups);
    const selectedGroupId = useSelector(state => state.allMarkets.selectedMarketGroup);
    const isMarketsCollapsed = useSelector(state => state.allMarkets.isMarketsCollapsed);

    const notEmptyMarketGroups = useMemo(() => {
        return marketGroups.filter(group => {
            const notEmptyTemplates = filterTemplatesByMarketType({
                templates: filterTemplatesByMarketStatus({
                    templates: group.templateList,
                    markets,
                }),
                markets,
            });

            return notEmptyTemplates.length > 0;
        });
    }, [marketGroups, markets]);

    const moreGroupOptions = useMemo(() => {
        return notEmptyMarketGroups.slice(groupLimit).map(group => ({
            value: group.id,
            label: group.name,
        }));
    }, [notEmptyMarketGroups]);
    const selectedOption = moreGroupOptions.find(group => group.value === selectedGroupId) || null;

    const onGroupOptionChange = group => {
        dispatch(setSelectedMarketGroup(group.value));
    };

    const onGroupSelect = groupId => {
        dispatch(setSelectedMarketGroup(groupId));
    };

    const onCollapseClick = () => {
        const newCollapseState = !isMarketsCollapsed;

        dispatch(setMarketsCollapsed(newCollapseState));

        LocalStorage.setItem('isMarketsCollapsed', newCollapseState);
    };

    return (
        <div className={'flex align-center justify-between'}>
            <div className={'flex align-center'}>
                <div
                    className={`${styles.group} ${
                        selectedGroupId === MARKET_GROUPS_ALL_ID ? styles.active : ''
                    }`}
                    onClick={() => onGroupSelect(MARKET_GROUPS_ALL_ID)}
                >
                    {getTranslation('marketGroupsAllOption')}
                </div>
                {notEmptyMarketGroups.slice(0, groupLimit).map(group => {
                    return (
                        <div
                            key={group.id}
                            className={`${styles.group} ${
                                selectedGroupId === group.id ? styles.active : ''
                            }`}
                            onClick={() => onGroupSelect(group.id)}
                        >
                            {group.name}
                        </div>
                    );
                })}
            </div>
            <div className={'flex'}>
                <div className={styles.collapseAllContainer} onClick={onCollapseClick}>
                    <span>
                        {isMarketsCollapsed
                            ? getTranslation('marketGroupsExpand')
                            : getTranslation('marketGroupsCollapse')}
                    </span>
                    <div className={styles.collapseAllIcons}>
                        <span className='icon-arrow-down' />
                        <span className='icon-arrow-down' />
                    </div>
                </div>
                {moreGroupOptions.length ? (
                    <Select
                        className={`common-select common-select--groups`}
                        classNamePrefix='common'
                        menuPlacement={'auto'}
                        isSearchable={false}
                        placeholder={getTranslation('marketGroupsMorePlaceholder')}
                        value={selectedOption}
                        onChange={onGroupOptionChange}
                        options={moreGroupOptions}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default MarketGroups;
